import { allCategories } from "@/lib/video";
import { durationFilterOptions, timeFilterOptions } from "@/lib/video";

interface FilterPanelProps {
  currentType: string;
  time: string;
  duration: string;
  tagOptions: string[];
  selectedTags: string[];
  onTypeChange: (slug: string) => void;
  onTimeChange: (value: string) => void;
  onDurationChange: (value: string) => void;
  onToggleTag: (tag: string) => void;
  onClear: () => void;
  hasActiveFilter: boolean;
}

function GroupTitle({ icon, title }: { icon: string; title: string }) {
  return (
    <h4 className="mb-3 flex items-center gap-1.5 text-sm font-medium text-foreground-900">
      <i className={`${icon} text-base text-primary-500`} />
      {title}
    </h4>
  );
}

export default function FilterPanel({
  currentType,
  time,
  duration,
  tagOptions,
  selectedTags,
  onTypeChange,
  onTimeChange,
  onDurationChange,
  onToggleTag,
  onClear,
  hasActiveFilter,
}: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-1.5 text-base font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-500" />
          筛选条件
        </h3>
        {hasActiveFilter && (
          <button
            type="button"
            onClick={onClear}
            className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
          >
            清空筛选
          </button>
        )}
      </div>

      <div>
        <GroupTitle icon="ri-layout-grid-line" title="内容类型" />
        <div className="flex flex-wrap gap-2">
          {allCategories.map((cat) => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => onTypeChange(cat.slug)}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                currentType === cat.slug
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div>
        <GroupTitle icon="ri-calendar-line" title="上传时间" />
        <div className="flex flex-col gap-2">
          {timeFilterOptions.map((option) => (
            <label
              key={option.value}
              className="flex cursor-pointer items-center gap-2 text-sm text-foreground-700"
            >
              <input
                type="radio"
                name="upload-time"
                checked={time === option.value}
                onChange={() => onTimeChange(option.value)}
                className="h-4 w-4 cursor-pointer accent-primary-500"
              />
              {option.label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <GroupTitle icon="ri-timer-line" title="时长范围" />
        <div className="flex flex-col gap-2">
          {durationFilterOptions.map((option) => (
            <label
              key={option.value}
              className="flex cursor-pointer items-center gap-2 text-sm text-foreground-700"
            >
              <input
                type="radio"
                name="duration"
                checked={duration === option.value}
                onChange={() => onDurationChange(option.value)}
                className="h-4 w-4 cursor-pointer accent-primary-500"
              />
              {option.label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <GroupTitle icon="ri-price-tag-3-line" title="热点标签" />
        <div className="flex flex-wrap gap-2">
          {tagOptions.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onToggleTag(tag)}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                selectedTags.includes(tag)
                  ? "border-accent-500 bg-accent-100 text-accent-800"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-accent-300"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}